var team24 = [
  [
    {
      name: "Prof. Priyanka Ghosh",
      post: "HOD",
      fb: "https://www.facebook.com/profile.php?id=100005799362676",
      insta: "https://www.instagram.com/govind_gupta_46/",
      linkedin:
        "https://www.linkedin.com/in/priyanka-ghosh-33173314/?originalSubdomain=in",
      website: "https://iitk.ac.in/new/priyanka-ghosh",
      mail: "mailto:priyog@iitk.ac.in",
      image: "/team/team23/priyanka-ghosh-iitk.jpg",
    },
    {
      name: "Prof. Chunendra Sahu",
      post: "Faculty Adivsor",
      fb: "https://www.facebook.com/profile.php?id=100005799362676",
      insta: "https://www.instagram.com/govind_gupta_46/",
      linkedin: "https://www.linkedin.com/in/chunendra-k-sahu-b90aa33a",
      website: "https://www.iitk.ac.in/new/chunendra-k-sahu",
      mail: "mailto:cksahu@iitk.ac.in",
      image: "/team/team23/cksahu.jpg",
    },
  ],
  [
    {
      id: "1",
      name: "Pranay Saxena",
      post: " Events",
      fb: "https://www.facebook.com/profile.php?id=100006906991000&mibextid=ZbWKwL",
      insta: "https://www.instagram.com/pranay_s22/",
      linkedin: "https://www.linkedin.com/in/pranay-saxena-0971aa258/",
      mail: "mailto:pranays22@iitk.ac.in",
      image: "/team/team23/Pranay_events.jpg",
    },
    {
      id: "2",
      name: "Sahil Arolia",
      post: " Web ",
      fb: " ",
      insta: "https://instagram.com/sahil_arolia?igshid=ZDc4ODBmNjlmNQ== ",
      linkedin: "https://www.linkedin.com/in/sahil-arolia-1a2bb8259",
      mail: "mailto:asahil22@iitk.ac.in",
      image: "/team/team23/Sahil Arolia.jpg",
    },
    {
      id: "4",
      name: "Deepesh Maurya",
      post: " Web ",
      fb: "https://www.facebook.com/dipesh.maurya.940",
      insta: "https://instagram.com/djshakya_?igshid=NGExMmI2YTkyZg==",
      linkedin: "http://www.linkedin.com/in/deepesh-maurya-386486251",
      mail: "mailto:deepeshm22@iitk.ac.in",
      image: " /team/team23/WebDev_Deepesh.jpg",
    },
    {
      id: "3",
      name: "Kuldeep",
      post: " Desgin ",
      fb: " ",
      insta: "https://instagram.com/kuldeep_0_555?igshid=ZDc4ODBmNjlmNQ==",
      linkedin: "https://www.linkedin.com/in/kuldeep-singh-76295b256",
      mail: "mailto:kuldeepb22@iitk.ac.in",
      image: "/team/team23/WebDev_Kuldeep.jpeg",
    },
    {
      id: "5",
      name: "Ruthvik Sai Kalahastri",
      post: " Marketing & Finance ",
      fb: "https://www.facebook.com/kalahastriruthvik2005/",
      insta: "https://www.instagram.com/ruthvik_2005_/",
      linkedin: "https://www.linkedin.com/in/ruthvik-sai-kalahastri-525100261/",
      mail: "mailto:ksruthvik22@iitk.ac.in",
      image: "/team/team23/Finance_Ruthwik.jpg",
    },
    {
      id: "6",
      name: "Lokesh Sunda",
      post: "Marketing & Finance ",
      fb: "",
      insta:
        "https://www.instagram.com/lokeshsunda2004?igsh=MXNiZ212dnZyc2J6ZQ==",
      linkedin: "https://www.linkedin.com/in/lokesh-sunda-7b0773260/",
      mail: "mailto:lokeshs22@iitk.ac.in",
      image: "/team/team23/Finance_lokesh.jpg",
    },
    {
      id: "7",
      name: "Devagya Singh Vats",
      post: " Content and Projects ",
      fb: "https://www.facebook.com/profile.php?id=100086680848212",
      insta: "https://www.instagram.com/devagyavats?igsh=bjlqZHFsd3JoNHNp",
      linkedin:
        "https://www.linkedin.com/in/devagya-vats-a30657261?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:devagyasv22@iitk.ac.in",
      image: "/team/team23/devagya_dp.jpg",
    },
    {
      id: "8",
      name: "Rithvik L",
      post: "Content and Projects  ",
      fb: "https://www.facebook.com/rithvik.lok/",
      insta: "https://www.instagram.com/rithviklok/",
      linkedin: "https://www.linkedin.com/in/rithvik-l-b84231189/",
      mail: "mailto:rithvikl23@iitk.ac.in",
      image: "/team/team23/Rithvik L_content.jpg",
    },
    {
      id: "9",
      name: "Gousia Karishma Syed ",
      post: "Events ",
      fb: "Karishma Syed",
      insta: "https://www.instagram.com/karishma___syed/",
      linkedin: "http://www.linkedin.com/in/gousia-karishma-syed",
      mail: "mailto:sgousia23@iitk.ac.in",
      image: "/team/team23/Gousia_Karishma_Syed__Events.jpg",
    },
    {
      id: "10",
      name: "Bandi Samanvitha",
      post: " Events   ",
      fb: "",
      insta: "",
      linkedin:
        "https://www.linkedin.com/in/samanvitha-bandi-79baa9290?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BVtWS%2BDdCQUOJ0d6XXLT6Rg%3D%3D",
      mail: "mailto:bandis23@iitk.ac.in",
      image: "/team/team23/Bandi Samanvitha_Events.jpg",
    },
  ],
  [
    {
      id: "1",
      name: "Mayank Agrawal",
      post: "Finance and Marketing",
      fb: "https://www.facebook.com/profile.php?id=100094739360139&mibextid=ZbWKwL",
      insta: "https://www.instagram.com/mynk_agrl?igsh=YmZkN21tbjJxcncx",
      linkedin:
        "https://www.linkedin.com/in/mayank-agrawal-64a120290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:mayankag23@iitk.ac.in",
      image: "/team/team24/Finance_MayankAgrawal.jpg",
    },
    {
      id: "2",
      name: "Love Chourasia",
      post: "Web",
      fb: "",
      insta: "https://www.instagram.com/love_chourasia?igsh=bzlyZWdleTZmdnY0",
      linkedin: "https://www.linkedin.com/in/love-chourasia-76a80a287",
      mail: "mailto:lovec23@iitk.ac.in",
      image: "/team/team24/Web_LoveChourasia.jpg",
    },
    {
      id: "3",
      name: "Divyansh Vasesi",
      post: "Events",
      fb: "",
      insta: "https://www.instagram.com/divyanshvasesi?igsh=cmxicGs2N255ZW90",
      linkedin:
        "https://www.linkedin.com/in/divyansh-vasesi-852330299?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:vdivyansh23@iitk.ac.in",
      image: "/team/team24/Events_DivyanshVasesi.jpg",
    },
    {
      id: "4",
      name: "Harsha Sharma",
      post: "Design",
      fb: "",
      insta:
        "https://www.instagram.com/_harshasharma1118?igsh=MWVkd3lpcTJmZG42bA==",
      linkedin: "https://www.linkedin.com/in/harsha-sharma-b2b23b314/",
      mail: "mailto:harshas23@iitk.ac.in",
      image: "/team/team24/Design_HarshaSharma.jpg",
    },
    {
      id: "5",
      name: "Laksh Verma",
      post: "Content",
      fb: "https://www.facebook.com/laksh.mats/about/",
      insta: "https://www.instagram.com/laksh_18lv/",
      linkedin: "https://www.linkedin.com/in/laksh-verma-32a179207/",
      mail: "mailto:lakshv23@iitk.ac.in",
      image: "/team/team24/Content_LakshVerma.png",
    },
    {
      id: "6",
      name: "Shubhangam Raj",
      post: "Events",
      fb: "https://www.facebook.com/profile.php?id=61559521227618&mibextid=ZbWKwL",
      insta:
        "https://www.instagram.com/shubhangam_raj?igsh=MXg0aWNzdzlpY3M5Yw==",
      linkedin:
        "https://www.linkedin.com/in/shubhangam-raj-455a5b286?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:shubhraj23@iitk.ac.in",
      image: "/team/team24/Events_ShubhangamRaj.jpg",
    },
    {
      id: "7",
      name: "Piyush Kumar",
      post: "Events",
      fb: "https://www.facebook.com/profile.php?id=100010436686493&mibextid=kFxxJD",
      insta:
        "https://www.instagram.com/piyush_kumar16_?igsh=MTFoNXVwdWpoN2pncA==",
      linkedin:
        "https://www.linkedin.com/in/piyush-kumar-603462282?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:piyushk23@iitk.ac.in",
      image: "/team/team24/Events_PiyushKumar.jpg",
    },
    {
      id: "8",
      name: "Sanyam Jain",
      post: "Finance and Marketing",
      fb: "",
      insta: "https://www.instagram.com/sanyam_4705?igsh=YTkycmNqdGs5aXpi",
      linkedin:
        "https://www.linkedin.com/in/sanyam-jain-8865912a7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:sanyamjain23@iitk.ac.in",
      image: "/team/team24/Finance_SanyamJain.jpg",
    },
    {
      id: "9",
      name: "Siddhant Singh",
      post: "Web",
      fb: "",
      insta: "https://www.instagram.com/siddhant.singh021/",
      linkedin: "http://www.linkedin.com/in/siddhant-singh-a90913307",
      mail: "mailto:siddhant23@iitk.ac.in",
      image: "/team/team24/Web_SiddhantSingh.jpg",
    },
    {
      id: "10",
      name: "Kanika Kumari",
      post: "Finance",
      fb: "",
      insta: "https://www.instagram.com/kanika_865_/",
      linkedin: "https://www.linkedin.com/in/kanika-kumari-350351306/",
      mail: "mailto:kanikak23@iitk.ac.in",
      image: "/team/team24/Finance_KanikaKumari.jpg",
    },
    {
      id: "11",
      name: "Yash Pathak",
      post: "Web",
      fb: "https://www.facebook.com/yash.pathak.1610",
      insta: "https://www.instagram.com/theyashhpathak__/",
      linkedin: "https://www.linkedin.com/in/yash-pathak-24802128b/",
      mail: "mailto:yashp23@iitk.ac.in",
      image: "/team/team24/Web_YashPathak.jpg",
    },
    {
      id: "12",
      name: "Rahul",
      post: "Design",
      fb: "",
      insta:
        "https://www.instagram.com/rahulshishram?igsh=MWF1bjJtZW5uM2gzeg==",
      linkedin: "",
      mail: "mailto:rahul23@iitk.ac.in",
      image: "/team/team24/Design_Rahul.jpg",
    },
    {
      id: "13",
      name: "Yash Kumar",
      post: "Events",
      fb: "https://m.facebook.com/profile.php?id=100055586395659&name=STSDirectNavUserDecorator",
      insta: "https://www.instagram.com/yashk_1278?igsh=MTBnNTN2Nmw0bjBmag==",
      linkedin: "https://www.linkedin.com/in/yash-kumar-51279b295",
      mail: "mailto:yashkmr23@iitk.ac.in",
      image: "/team/team24/Events_YashKumar.jpg",
    },
    {
      id: "14",
      name: "Roushan Raj",
      post: "Web",
      fb: "",
      insta: "https://www.instagram.com/roushanraj.1047/",
      linkedin: "https://www.linkedin.com/in/roushan-raj-22a0a4280/",
      mail: "mailto:roushanraj23@iitk.ac.in",
      image: "/team/team24/Web_RoushanRaj.jpg",
    },
    {
      id: "15",
      name: "Nishant Singh",
      post: "Marketing and Finance",
      fb: "https://www.facebook.com/profile.php?id=100025239159894",
      insta:
        "https://www.instagram.com/nishantsiingh?igsh=MTNxZHFoMmR2ZTR4eg==",
      linkedin: "https://www.linkedin.com/in/nishant-singh-429a582a3",
      mail: "mailto:snishant23@iitk.ac.in",
      image: "/team/team24/Finance_NishantSingh.jpg",
    },
    {
      id: "16",
      name: "Divyaman Pal",
      post: "Events",
      fb: "https://www.facebook.com/share/3dtr6X1XeiVaHjYw/?mibextid=qi2Omg",
      insta: "https://www.instagram.com/divyaman_pal?igsh=NXJ1Yjk3OTgxdTVv",
      linkedin:
        "https://www.linkedin.com/in/divyaman-pal-9089b1292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:divyamp23@iitk.ac.in",
      image: "/team/team24/Events_DivyamanPal.jpg",
    },
    {
      id: "17",
      name: "Sushant Kumar",
      post: "Web",
      fb: "https://www.facebook.com/profile.php?id=100048598550916",
      insta: "https://www.instagram.com/sushant_kumar7628/",
      linkedin: "https://www.linkedin.com/in/sushant-kumar-a916b627a/",
      mail: "mailto:sushantk23@iitk.ac.in",
      image: "/team/team24/Web_SushantKumar.jpg",
    },
    {
      id: "18",
      name: "Ashish Porwal",
      post: "Events",
      fb: "https://www.facebook.com/profile.php?id=100074288510995",
      insta: "https://www.instagram.com/uday_aspirant__?igsh=aGJ4dnFsMGVmd3gx",
      linkedin: "https://in.linkedin.com/in/ashish-porwal-a74734313",
      mail: "mailto:ashishp23@iitk.ac.in",
      image: "/team/team24/Events_AshishPorwal.jpg",
    },
    {
      id: "19",
      name: "Chinthala Manasa",
      post: "Marketing and Finance",
      fb: "",
      insta: "https://www.instagram.com/_manasa_0618?igsh=MWNyYmdvb2k5cDJmMw==",
      linkedin: "",
      mail: "mailto:chinthala23@iitk.ac.in",
      image: "/team/team24/Finance_ChinthalaManasa.jpg",
    },
    {
      id: "20",
      name: "Udit Choudhary",
      post: "Design",
      fb: "",
      insta:
        "https://www.instagram.com/uditt_17?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
      linkedin: "",
      mail: "mailto:uditc23@iitk.ac.in",
      image: "/team/team24/Design_UditChoudhary.jpg",
    },
    {
      id: "21",
      name: "Manoneet Gawali",
      post: "Content Secretary ",
      fb: "",
      insta:
        "https://www.instagram.com/manoneet.gawali?igsh=MXdhOTM5ejJqbXdyeQ%3D%3D&utm_source=qr",
      linkedin:
        "https://www.linkedin.com/in/manoneet-gawali-ba1312197?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      mail: "mailto:manoneetag23@iitk.ac.in",
      image: "/team/team24/Content_ManoneetGawali.jpg",
    },
    {
      id: "22",
      name: "Tushar chaube ",
      post: "Events ",
      fb: "",
      insta:
        "https://www.instagram.com/_tushar_chaube_29?igsh=MTlqbzFleDYyM3Ny",
      linkedin:
        "https://www.linkedin.com/in/tushar-chaube-b26352299?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:tusharan23@iitk.ac.in",
      image: "/team/team24/Events_Tusharchaube.jpg",
    },
    {
      id: "23",
      name: "Shreya Todmal",
      post: "Design",
      fb: "",
      insta:
        "https://www.instagram.com/shreya_todmal?igsh=MWI5a3Vjbjh2MHR4aw==",
      linkedin:
        "https://www.linkedin.com/in/shreya-todmal-a240b5205?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      mail: "mailto:shreyat23@iitk.ac.in",
      image: "/team/team24/Desgin_ShreyaTodmal.jpg",
    },
    {
      id: "24",
      name: "Shivesh Kumar Verma",
      post: "Events",
      fb: "https://www.facebook.com/shivesh.verma.18",
      insta: "https://www.instagram.com/shivesh_verma30/",
      linkedin: "https://www.linkedin.com/in/shivesh-verma-522046159/",
      mail: "mailto:shiveshv23@iitk.ac.in",
      image: "/team/team24/Events_ShiveshKumarVerma.jpg",
    },
  ],
];

module.exports = team24;
